import { FlaskConical, Server, TrendingUp, Briefcase, Megaphone, Leaf } from "lucide-react";

export const SERVICES = [
  {
    id: "research",
    name: "Research",
    icon: FlaskConical,
    tagline: "Analytical research for your business success.",
    price: 450000,
    image: "/assets/research.jpg",
    description:
      "Data-driven market and field research to power confident decision-making. We deliver actionable insights across industrial and agricultural sectors.",
    features: ["Market & feasibility studies", "Data collection & analysis", "Competitive intelligence", "Impact assessment reports"],
  },
  {
    id: "it",
    name: "Information Technology",
    icon: Server,
    tagline: "IT & technological solutions for your business.",
    price: 800000,
    image: "/assets/infortech.jpg",
    description:
      "Modern software, infrastructure and digital transformation services that keep your enterprise competitive and secure.",
    features: ["Web & mobile development", "Cloud & infrastructure", "Systems integration", "Cyber-security consulting"],
  },
  {
    id: "trading",
    name: "Trading",
    icon: TrendingUp,
    tagline: "Trading of commodities & distribution simplified.",
    price: 600000,
    image: "/assets/service-trading.webp",
    description:
      "Linking producers and consumers across the global market. We simplify trading and distribution of industrial and agricultural products.",
    features: ["Import & export facilitation", "Commodity sourcing", "Distribution logistics", "Global market linkage"],
  },
  {
    id: "consulting",
    name: "Consulting",
    icon: Briefcase,
    tagline: "Consultancy services in many areas of interest.",
    price: 750000,
    image: "/assets/consulting.jpg",
    description:
      "Strategic technical consultancy for profit and non-profit organizations. We help you build enterprises, develop talent and access capital.",
    features: ["Business strategy", "Enterprise development", "Capital access advisory", "Seminars & training"],
  },
  {
    id: "marketing",
    name: "Marketing",
    icon: Megaphone,
    tagline: "Strategic marketing for your business growth.",
    price: 500000,
    image: "/assets/marketing.jpg",
    description:
      "Growth-focused marketing strategy and execution to help your brand reach domestic and international markets.",
    features: ["Brand strategy", "Digital marketing", "Go-to-market planning", "Campaign management"],
  },
  {
    id: "environmental",
    name: "Environmental",
    icon: Leaf,
    tagline: "Conservation & carbon footprint reduction.",
    price: 650000,
    image: "/assets/environmental.jpg",
    description:
      "Environmental conservation consultancy that helps your company reduce its carbon footprint and operate sustainably.",
    features: ["Carbon footprint audits", "Sustainability strategy", "Conservation projects", "Compliance advisory"],
  },
];

export const PLANS = [
  {
    id: "basic",
    name: "Basic",
    price: 150000,
    tagline: "For startups exploring their first advisory.",
    features: ["1 consultation / month", "Email support", "Monthly market brief", "Access to resource library", "1 service area"],
    highlight: false,
  },
  {
    id: "standard",
    name: "Standard",
    price: 350000,
    tagline: "For growing enterprises that need ongoing support.",
    features: ["4 consultations / month", "Priority email & phone support", "Weekly market briefs", "Quarterly strategy review", "2 service areas"],
    highlight: true,
  },
  {
    id: "premium",
    name: "Premium",
    price: 700000,
    tagline: "Full-scale partnership across all service areas.",
    features: ["Unlimited consultations", "Dedicated account manager", "All 6 service areas", "Custom research reports", "On-site seminars"],
    highlight: false,
  },
];

export const EXECUTIVES = [
  {
    name: "Ernest T. Magawa",
    role: "Founder & Chief Executive Officer",
    badge: "Founder",
    tagline: "Message from the CEO",
    image: "/team/ernest-magawa.jpg",
    bio: "As the Founder & Chief Executive Officer, Mr. Magawa oversees all strategic and operational functions of the company, including marketing strategies. He provides leadership that positions the company near the forefront of the industry, and has developed a strategic plan to advance the company's missions and objectives, as well as ways to promote revenue, profitability and growth as an organization. He promises to oversee the company's operations in a way that will ensure efficient services, quality, and cost-effective management of resources.",
    quote: "I believe that it is our responsibility to engage our communities, businesses and families, to educate and encourage ethical standards in our business dealings, to promote the value of honesty, to take action and to share our success with others who will engage in ethical behaviors as we do. At Tanz – BRIDGE International Ltd, I'm proud to be a part of a team that recognizes the importance of ethics, and takes action to drive positive change for our well-being as a society.",
  },
  {
    name: "Martin J. Kidenya",
    role: "Managing Director & Co-Founder",
    badge: "Co-Founder",
    tagline: "Message from the Managing Director",
    image: "/team/martin-kidenya.jpg",
    bio: "As a Director and Co-founder, Mr. Kidenya acts as liaison to the Managing Director, Executive Team and Department Directors for issues, daily communication, planning, and information requiring the Managing Director's attention. He maintains awareness and understanding of past, current and potential division issues and affairs including budget, business plan, capital projects, policies and politics. He anticipates emerging issues, discerns potential impacts, and provides the Founder & Chief Executive Officer with awareness, information and independent analysis in a timely manner — ensuring all strategic or policy issues are addressed promptly.",
    quote: "To paraphrase Bernard Loomis, the trouble with research is that it tells you what people were thinking about yesterday, not tomorrow. It's like driving a car using a rearview mirror. At Tanz – BRIDGE International Ltd research is an integral part of the business, and being part of a team, our focus is to enhance the quality of research for our clients. Our challenge is to provide the best work for the business world and to prove that research, when done well, is better for investors, businesses, and the communities we serve.",
  },
];

export const TEAM = [
  { name: "Emmanuel Kessy", role: "Head of Information Technology", area: "IT", image: "/assets/emmanuel.jpg" },
  { name: "Wilbert Mahenge", role: "Research Coordinator", area: "Research", image: "/assets/wilbert.jpg", bio: "With his vast research experience, Mr. Mahenge coordinates the day-to-day activities of research protocols and assists project managers and analysts with aspects of project logistics and administration. He is actively involved in data collection efforts, including in-depth interviewing and secondary research. His key responsibilities include manipulation of large datasets, analysis of survey data, report writing and data presentation, and other market research and evaluation tasks as needed. He also assists with various marketing and administrative tasks as deemed necessary." },
  { name: "Daniel Mecky", role: "Head of Consulting", area: "Consulting", image: "/assets/daniel.jpg" },
  { name: "Neema Mushi", role: "Head of Trading", area: "Trading", image: "/assets/neema.jpg" },
  { name: "Salma Abdalah", role: "Head of Marketing", area: "Marketing", image: "/assets/salma.jpg" },
  { name: "Peter Haule", role: "Head of Environmental Services", area: "Environmental", image: "/assets/peter.jpg" },
];

export const MISSION_IMG = "/assets/entrepreneur.png";

export const LOGO_URL = "/assets/tanz-full-logo.png";

export const HERO_VIDEO = "/hero/hero-loop.mp4";

export const HERO_BG = "/hero/hero-bg.jpg";

export const formatTZS = (n) =>
  new Intl.NumberFormat("en-TZ", { maximumFractionDigits: 0 }).format(n) + " TZS";
